import { Link } from "react-router-dom";
import placeholder from "assets/img/placeholder.jpg";
import CheckSvgComponent from "assets/svg/checked.svg";
import PinSvgComponent from "assets/svg/location.svg";
import Image from "components/image/image.component";
import { CoverPhoto } from "components/image/avatar.component";
import { Business, House } from "store/service/service.types";
import { useEffect } from "react";
import { formatCurrency, Rating } from "./service_rating";

export const Avalibility = ({ value }: { value: string }) => {
  switch (value) {
    case "Available":
      return (
        <span className="text-sm text-[#01CD22] font-semibold">{value}</span>
      );
    case "Working":
      return (
        <span className="text-sm text-orange-600 font-semibold">{value}</span>
      );
    case "Booked":
      return (
        <span className="text-sm text-purple-600 font-semibold">{value}</span>
      );

    default:
      return (
        <span className="text-sm text-orange-600 font-semibold">{value}</span>
      );
  }
};
function ServiceProviderItem({
  item,
  house,
}: {
  item?: Business;
  house?: House;
}) {
  const isHouse = house;

  useEffect(() => {}, [isHouse]);

  return (
    <div className="card bg-base-100 shadow-xl p-0">
      <figure>
        {isHouse ? (
          <Image
            src={house?.image}
            alt={house?.title}
            placeholderSrc={placeholder}
            className="object-cover w-full h-60"
            sizes="(max-width: 600px) 180px, 400px"
            wrapperClassName="w-full"
          />
        ) : (
          <CoverPhoto
            src={item?.profileImage}
            name={item?.businessName}
            className="h-60">
            {(onError) => (
              <Image
                src={item?.profileImage}
                alt={item?.businessName}
                placeholderSrc={placeholder}
                onError={onError}
                className="object-cover w-full h-60"
                sizes="(max-width: 600px) 180px, 400px"
                wrapperClassName="w-full"
              />
            )}
          </CoverPhoto>
        )}
      </figure>
      <div className="card-body px-4 py-3">
        <h2 className="card-title justify-between text-base font-medium">
          <span className="flex items-center gap-2">
            {isHouse ? house?.title : item?.businessName}
            <CheckSvgComponent />
          </span>
          {isHouse && (
            <span className="text-orange-600">
              {formatCurrency(Number(house.amount)).replace("$", "₦")}
            </span>
          )}
        </h2>
        <div className="flex items-center justify-between text-base font-medium">
          <span className="flex items-center gap-2">
            {isHouse ? (
              <span
                style={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 2, // Limits the text to 2 lines
                  lineHeight: "1.2em", // Adjust based on your needs
                  maxHeight: "2.4em", // Should be lineHeight * number of lines
                }}
              >
                {house?.description}
              </span>
            ) : (
              <span>
                <Rating rate={item!.ratingAverage!} />
                <span>{item?.ratingAverage?.toFixed(1)}</span>
              </span>
            )}
          </span>
          {!isHouse && <Avalibility value={item!.availability} />}
        </div>

        <div className="flex items-center justify-between text-sm font-normal">
          {isHouse ? (
            <span className="flex items-center gap-1">
              <PinSvgComponent />
              <span
                style={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 1, // Limits the text to 2 lines
                  lineHeight: "1.2em", // Adjust based on your needs
                  maxHeight: "2.4em", // Should be lineHeight * number of lines
                }}
              >
                {house?.address}
              </span>
            </span>
          ) : (
            <span></span>
          )}
          <Link
            to={
              isHouse
                ? `/house/${house?._id}`
                : `/service-provider/${item?._id}`
            }
            className="btn btn-outline btn-sm btn-primary"
          >
            {!isHouse ? "View Profile" : "View"}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ServiceProviderItem;
